import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_1.css";
import Template_1_Header from "./Template_1_Header";
import Template_1_HeroSection from "./Template_1_HeroSection";
import Template_1_TravelTypes from "./Template_1_TravelTypes";
import Template_1_Destinations from "./Template_1_Destinations";
import Template_1_Packages from "./Template_1_Packages";
import Template_1_Reviews from "./Template_1_Reviews";
import Template_1_AboutUs from "./Template_1_AboutUs";
import Template_1_Footer from "./Template_1_Footer";
import Template_1_EnquiryPopup from "./Template_1_EnquiryPopup";
import Template_1_TopHeader from "./Template_1_TopHeader";
import Template_1_MainHeroSection from "./Template_1_MainHeroSection";

const Template_1_HomePage = () => {
  const [showEnquiryPopup, setShowEnquiryPopup] = useState(false);
  const [enquiryPackage, setEnquiryPackage] = useState(null);

  // Open enquiry popup (pass whole package object, not just name)
  const handleEnquireClick = (pkg) => {
    setEnquiryPackage(pkg);
    setShowEnquiryPopup(true);
  };

  // Close enquiry popup
  const handleCloseEnquiry = () => {
    setShowEnquiryPopup(false);
    setEnquiryPackage(null);
  };

  return (
    <div className="Template_1 homepage-template-1">
      <Template_1_TopHeader />
      <Template_1_Header />
      <Template_1_MainHeroSection />
      <Template_1_HeroSection />
      <Template_1_Packages onEnquireClick={handleEnquireClick} />
      <Template_1_TravelTypes />
      <Template_1_Destinations />
      <Template_1_Reviews />
      <Template_1_AboutUs />
      <Template_1_Footer />

      {/* Enquiry Popup */}
      {showEnquiryPopup && enquiryPackage && (
        <Template_1_EnquiryPopup
          packageDetails={enquiryPackage}
          onClose={handleCloseEnquiry}
        />
      )}
    </div>
  );
};

export default Template_1_HomePage;
